module.exports = __webpack_public_path__ + "img/priceImg-2.25311048.png";